import React, { ReactElement, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { makeSelectHasIncompleteSprayEvents } from './selectors';

interface Props {
    fallback?: ReactElement | ReactNode;
    children: ReactElement | ReactNode;
}

export default function SprayEventHasIncompleteEventsGate(
    props: Props
): ReactElement | null {
    const { children, fallback } = props;

    const hasIncompleteSprayEvents = useSelector(
        makeSelectHasIncompleteSprayEvents()
    );

    if (hasIncompleteSprayEvents) {
        return <React.Fragment>{children}</React.Fragment>;
    }

    if (fallback) {
        return <React.Fragment>{fallback}</React.Fragment>;
    }

    return null;
}
